import React from 'react';
export function FlymillSection() {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden mb-12 transition-shadow hover:shadow-lg" data-id="element-1298">
      <div className="flex flex-col md:flex-row" data-id="element-1299">
        <div className="md:w-5/12 p-8 flex items-center justify-center bg-gray-50 border-b md:border-b-0 md:border-r border-gray-100" data-id="element-1300">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Flymill.png" alt="FLYMILL" className="block max-w-full h-auto object-contain max-h-[300px]" data-id="element-1301" />
        </div>
        <div className="md:w-7/12 p-8 flex flex-col" data-id="element-1302">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-2" data-id="element-1303">
            FLYMILL
          </h3>
          <h4 className="text-lg font-semibold text-navy mb-4 leading-snug" data-id="element-1304">
            High Power and High Precision Modular 5-Axis Vertical Gantry
            Machining Center
          </h4>
          <div className="text-gray-700 mb-6 flex-grow space-y-4" data-id="element-1305">
            <p className="leading-relaxed" data-id="element-1306">
              Breton Flymill is the machining center designed for companies
              operating with very large workpieces and, especially, for
              machining of tough materials that require{' '}
              <strong data-id="element-1307">high power and torque</strong>. With{' '}
              <strong data-id="element-1308">Z axis strokes up to 1,500 mm</strong>, cross strokes up
              to 4,000 mm and longitudinal strokes up to 30,000 mm, Flymill is
              the machining center for tough materials with the highest
              operating volume in the Breton range. This machine is
              distinguished by its{' '}
              <strong data-id="element-1309">
                ability to combine milling and turning in a single set-up
              </strong>
              , exploiting the potential of the <strong data-id="element-1310">turning table</strong>{' '}
              and the <strong data-id="element-1311">automatic heads store</strong> to automatically
              switch from the powerful milling head to the boring bar head
              during the machining process.
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 text-sm" data-id="element-1312">
              <div className="grid sm:grid-cols-2 gap-4" data-id="element-1313">
                <div data-id="element-1314">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1315">
                    FLYMILL 1000 K20/30/45/60/80
                  </strong>
                  <p className="text-xs" data-id="element-1316">
                    X: 78.7-118 - 177 - 236.2 - 315 in.
                    <br data-id="element-1317" />
                    Y: 98.4 - 157.5 in
                    <br data-id="element-1318" />
                    Z: 39.4 in.
                  </p>
                </div>
                <div data-id="element-1319">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1320">
                    FLYMILL 1300 K20/30/45/60/80
                  </strong>
                  <p className="text-xs" data-id="element-1321">
                    X: 78.7-118 - 177 - 236.2 - 315 in.
                    <br data-id="element-1322" />
                    Y: 98.4 - 157.5 in
                    <br data-id="element-1323" />
                    Z: 51.1 in.
                  </p>
                </div>
                <div data-id="element-1324">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1325">
                    FLYMILL 1600 K20/30/45/60/80
                  </strong>
                  <p className="text-xs" data-id="element-1326">
                    X: 118 - 177 - 236.2 - 315 in.
                    <br data-id="element-1327" />
                    Y: 157.5 in.
                    <br data-id="element-1328" />
                    Z: 63 in.
                  </p>
                </div>
                <div data-id="element-1329">
                  <strong className="text-navy block mb-1 text-xs" data-id="element-1330">
                    FLYMILL 2000 K45/60/80
                  </strong>
                  <p className="text-xs" data-id="element-1331">
                    X: 177 - 236.2 - 315 in.
                    <br data-id="element-1332" />
                    Y: 137.8 in.
                    <br data-id="element-1333" />
                    Z: 78.7 in.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-1334">
            <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20FlyMill" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1335">
              <span className="mr-2" data-id="element-1336">+</span> Request Quote
            </a>
            <a href="https://www.breton.it/products/machines-and-lines/breton-flymill" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1337">
              <span className="mr-2" data-id="element-1338">+</span> Additional Information
            </a>
          </div>
        </div>
      </div>
    </div>;
}